export const joinedWinningCombination = (playerComb: string[], dealerComb: string[]) => playerComb.map((el: string, i: number) => (el === "1" || dealerComb[i] === '1') ? '1' : '0')
